module.exports = __webpack_public_path__ + "static/media/executive-square.51300e39.jpg";